import { render, staticRenderFns } from "./TablaMotivos.vue?vue&type=template&id=72520f64"
import script from "./TablaMotivos.vue?vue&type=script&lang=js"
export * from "./TablaMotivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports